export default class APITenant {
  constructor(API) {
    this.api = API;
  }
  //Get tenant user file signed URLs
  async getConfiguration() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/tenant/config';
    return await req.exec();
  }
  async sendContactForm(formValue) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/contactUs';
    req.body = { ...formValue };
    return await req.exec();
  }
  //report
  async getAchievedCertificationsReport(from, to, isPreview) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/tenant/report/completedCertifications' + (isPreview ? '/preview' : '');
    req.appendQueryParam('from', from);
    req.appendQueryParam('to', to);
    if (!isPreview) req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }
  //email certificates
  async emailCertificates(emailCertsObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/tenant/certificates/email';
    req.body = { ...emailCertsObj };
    return await req.exec();
  }
  //pending approval items
  async pendingApprovals() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/tenant/pendingApprovals';
    return await req.exec();
  }
}
